import React from 'react'
import DataGrid from '../../../../table/DataGrid';

const FormGrowthGoalsPreview = ({ growthGoals = [] }) => {

  return (
    <div className='relative h-screen-half'>
      <DataGrid
        id='preview-worked-examples'
        showSetting={false}
        rows={growthGoals?.map((row, index) => {
          return {
            ...row,
            index: index + 1
          }
        })}
        rowsPerPage={growthGoals?.length || 0}
        columns={[
          { label: '#', key: 'index', align: 'center', width: 20, show: true, hide: false },
          { label: 'Question', key: 'question', show: true, hide: false },
        ]}
          labelNoRows="You don't have any question yet"
      />
    </div>
  )
}

export default FormGrowthGoalsPreview